import { Controller } from "@hotwired/stimulus";

/**
 * The language picker in the flyout.
 *
 * Each option carries the address of the page you are on in that language, which the server works
 * out and hands over as `locale_urls`; choosing one is therefore a navigation and not a setting to
 * save, and all this has to do is follow it.
 *
 * A full load rather than a Turbo visit. Everything on the page changes language at once, including
 * the `lang` attribute on the document and whatever the browser does with it, and a visit that
 * swaps the body leaves the old document around it.
 */
export default class extends Controller<HTMLElement> {
  static override targets = ["select"];

  declare readonly selectTarget: HTMLSelectElement;

  onChange(): void {
    const url = this.selectTarget.value;

    /* An option with nowhere to go: `locale_urls` is absent on a page rendered outside a request
       that could resolve it, and following "" would reload the page the reader is already on. */
    if (url === "") {
      return;
    }

    window.location.assign(url);
  }
}
